import React from 'react';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import { Row, Col, FormGroup, CustomInput, Label, Button } from 'reactstrap';
import ClientsTable from './ClientsTable';
import {
  ContFlexLeft,
  ContFlexRight,
  ContPaginationPage,
} from '../../styled-components';
import ModalNewClient from './ModalNewClient';
import SearchInput from '../../commons/SearchInput';
import ClientsImportFeedbackModal from './ClientsImportFeedbackModal';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import { useAlert } from 'react-alert';

const ClientsPresentational = ({
  data,
  profile,
  query,
  total,
  onFilter,
  onNewClientConfirm,
  searchAdministrators,
  onImportClients,
  toggleShowImportFeedback,
  clientsImportFeedbackData,
  hasImportedClients,
  checkTaxCode,
  searchEstateAgents,
  searchCommercials,
  searchAssociations,
  searchOffices,
}) => {
  const [t] = useTranslation('CUSTOMER_EXTRA');
  const alert = useAlert();
  const { offset, limit } = query;

  function handleImportFile(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportClients(data);
    }
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <ClientsImportFeedbackModal
          data={clientsImportFeedbackData}
          toggle={toggleShowImportFeedback}
          isOpen={hasImportedClients}
        />
        <section>
          <Header
            title={t('PAGES:CUSTOMER_EXTRA')}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />
          <Row className="align-items-center">
            <Col className="">
              <ContFlexRight>
                Numero di clienti:&nbsp;<strong>{total}</strong>
              </ContFlexRight>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col xs={12} style={{ marginBottom: 30 }}>
              <Button
                href={`/examples/Template_Clienti.csv`}
                target="_blank"
                color="primary"
              >
                Scarica template importazione
              </Button>
              <Button
                href={`/documentation/Extra_Importazione_clienti.pdf`}
                target="_blank"
                color="primary"
                style={{ marginLeft: '2rem' }}
              >
                Scarica documentazione importazione
              </Button>
            </Col>
            <Col sm="12" md="4">
              <ContFlexLeft>
                <ModalNewClient
                  profile={profile}
                  onConfirm={onNewClientConfirm}
                  searchAdministrators={searchAdministrators}
                  searchEstateAgents={searchEstateAgents}
                  searchCommercials={searchCommercials}
                  searchAssociations={searchAssociations}
                  searchOffices={searchOffices}
                  checkTaxCode={checkTaxCode}
                />
              </ContFlexLeft>
            </Col>
          </Row>

          <Row className="search-add-cont m-t-20">
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.businessName }}
                onFilter={({ search }) => onFilter({ businessName: search })}
                label={t('SEARCH:BUSINESS_NAME')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.taxCode }}
                onFilter={({ search }) => onFilter({ taxCode: search })}
                label={t('SEARCH:TAX_CODE')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.office }}
                onFilter={({ search }) => onFilter({ office: search })}
                label={t('SEARCH:BY_OFFICE')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <FormGroup>
                <CustomInput
                  type="file"
                  id="importFilee"
                  name="importFilee"
                  onChange={(event) => handleImportFile(event)}
                  accept=".csv"
                />
                <Label for="selectFile">
                  {t('CHOOSE_FILE')}
                  &nbsp;({t('MAX_UPLOAD_FILE_SIZE')})
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </section>

        <section className="m-t-20">
          <ClientsTable
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            truncateTable={profile && profile._id}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
      </div>
    </div>
  );
};

export default ClientsPresentational;
